import { ReactNode } from "react";

interface BasicButtonProps {
  clickHandler: () => void;
  children: ReactNode;
}

const BasicButton = ({ clickHandler, children }: BasicButtonProps) => {
  const btnClasses =
    "text-sky-600 font-medium mr-4 p-2 bg-white border border-stone-300 rounded-md shadow-sm";
  return (
    <button
      onClick={clickHandler}
      onTouchStart={clickHandler}
      className={btnClasses}
    >
      {children}
    </button>
  );
};

export { BasicButton };
